import projectsActionTypes from "Areas/Projects/redux/actionTypes";
import workSpacesActionTypes from "Areas/WorkSpaces/redux/actionTypes";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import omit from "lodash/omit";
import { NAMESPACE } from "../constants";
import getScope from "../utils/getScope";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        tableStatisticsData: {},
        overallStatisticsData: {},
        filterParams: {}
    }
};
export default createReducer(initialState, {
    [actionTypes.GET_TASK_STATISTICS_COMPLETED]: (state, { payload: { TaskStatistics, SourceStatistics, TotalCount, CompletedCount, ErrorCount, InProgressCount, CancelledCount, PendingCount }, meta }) => {
        const tableStatisticsData = { TaskStatistics, SourceStatistics };
        const overallStatisticsData = {
            TotalCount,
            CompletedCount,
            ErrorCount,
            InProgressCount,
            CancelledCount,
            PendingCount
        };
        const result = set(state, `[${NAMESPACE}].tableStatisticsData[${meta}]`, tableStatisticsData);
        return set(result, `[${NAMESPACE}].overallStatisticsData[${meta}]`, overallStatisticsData);
    },
    [actionTypes.SET_TASK_STATISTICS_FILTER_PARAMS]: (state, { params, meta }) => set(state, `[${NAMESPACE}].filterParams[${meta}]`, params),
    [actionTypes.CLEAR_ALL_TASK_STATISTICS_FILTER_PARAMS]: (state, { meta }) => set(state, `[${NAMESPACE}].filterParams[${meta}]`, {}),
    [workSpacesActionTypes.DELETE_WORK_SPACE_COMPLETED]: (state, { meta }) => {
        const scope = getScope(undefined, meta.workSpaceId);
        let result = set(state, `[${NAMESPACE}].tableStatisticsData`, omit(state[NAMESPACE].tableStatisticsData, scope));
        result = set(result, `[${NAMESPACE}].overallStatisticsData`, omit(state[NAMESPACE].overallStatisticsData, scope));
        result = set(result, `[${NAMESPACE}].filterParams`, omit(state[NAMESPACE].filterParams, scope));
        return result;
    },
    [projectsActionTypes.DELETE_PROJECT_COMPLETED]: (state, { meta }) => {
        const scope = getScope(meta.projectId, undefined);
        let result = set(state, `[${NAMESPACE}].tableStatisticsData`, omit(state[NAMESPACE].tableStatisticsData, scope));
        result = set(result, `[${NAMESPACE}].overallStatisticsData`, omit(state[NAMESPACE].overallStatisticsData, scope));
        result = set(result, `[${NAMESPACE}].filterParams`, omit(state[NAMESPACE].filterParams, scope));
        return result;
    }
});
